import { BaseModel } from "@blue-chip/core";

export default class Scope extends BaseModel {
  static get filterScopeModels() {
    return ["Vendor", "ConsultingCompany", "Office", "AddressBookContact"];
  }
}
